import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconUndo = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.53033 5.78033C8.82322 5.48744 8.82322 5.01256 8.53033 4.71967C8.23744 4.42678 7.76256 4.42678 7.46967 4.71967L3.96967 8.21967C3.82322 8.36612 3.75 8.55806 3.75 8.75C3.75 8.85169 3.77024 8.94866 3.80691 9.03709C3.84351 9.12555 3.89776 9.20842 3.96967 9.28033L7.46967 12.7803C7.76256 13.0732 8.23744 13.0732 8.53033 12.7803C8.82322 12.4874 8.82322 12.0126 8.53033 11.7197L6.31066 9.5H15C17.0711 9.5 18.75 11.1789 18.75 13.25C18.75 15.3211 17.0713 17 15.0002 17H9.5C9.08579 17 8.75 17.3358 8.75 17.75C8.75 18.1642 9.08579 18.5 9.5 18.5H15.0002C17.8998 18.5 20.25 16.1494 20.25 13.25C20.25 10.3505 17.8995 8 15 8H6.31066L8.53033 5.78033Z",
		fill: "currentColor"
	})
});
export { SvgIconUndo as ReactComponent };
